import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

const WaterIntakeGoalCircularIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.495 0.810625C6.21 0.563125 5.7825 0.563125 5.4975 0.810625C1.8375 4.03563 0 6.84063 0 9.22563C0 12.9606 2.85 15.3756 6 15.3756C9.15 15.3756 12 12.9606 12 9.22563C12 6.84063 10.1625 4.03563 6.495 0.810625ZM2.8725 9.37563C3.15 9.37563 3.375 9.57063 3.4275 9.84063C3.735 11.5056 5.1375 12.0756 6.1575 11.9931C6.48 11.9781 6.75 12.2331 6.75 12.5556C6.75 12.8556 6.51 13.1031 6.21 13.1181C4.6125 13.2156 2.745 12.3006 2.3175 10.0281C2.2575 9.69063 2.5275 9.37563 2.8725 9.37563Z"
        fill="#7D8797"
      />
    </SvgIcon>
  );
};

export default WaterIntakeGoalCircularIcon;
